/* Cart page: change a quantity without losing your place.

   The drawer re-renders itself after a mutation; this does the same for the
   page, asking Shopify for THIS section back and swapping it in. Same rule as
   everywhere else in this theme: the request returns server-rendered Liquid,
   so no total on this page was ever calculated in the browser.

   With JS off the page still lists everything and Check out still works,
   because that button is a real form post. Only the live quantity editing
   needs script. */
(function () {
  'use strict';

  function init(root) {
    var sectionId = root.dataset.sectionId;
    var errorEl = root.querySelector('[data-ak-cartp-error]');
    var busy = false;

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function setBusy(on) {
      busy = on;
      var body = root.querySelector('[data-ak-cartp-body]');
      if (body) body.setAttribute('aria-busy', on ? 'true' : 'false');
    }

    function change(line, quantity) {
      if (busy) return;
      setBusy(true);
      if (errorEl) errorEl.hidden = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: quantity, sections: sectionId })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart');
          return res.json();
        })
        .then(function (cart) {
          var html = cart.sections && cart.sections[sectionId];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-ak-cartp]');
            if (fresh) {
              root.innerHTML = fresh.innerHTML;
              bind();
            }
          }
          // the header pill and the drawer both listen for this
          document.dispatchEvent(new CustomEvent('ak:cart:changed', {
            detail: { itemCount: cart.item_count }
          }));
          var drawer = document.querySelector('ak-cart-drawer');
          if (drawer && typeof drawer.refresh === 'function') drawer.refresh();
        })
        .catch(function () {
          showError('Something went wrong updating the cart. Reload the page and it will be as you left it.');
        })
        .finally(function () { setBusy(false); });
    }

    function qtyFor(line) {
      var input = root.querySelector('[data-ak-cartp-qty][data-line="' + line + '"]');
      return Math.max(0, parseInt(input && input.value, 10) || 0);
    }

    function bind() {
      // delegated, so it survives the swap without rebinding every row
    }

    root.addEventListener('click', function (e) {
      var step = e.target.closest('[data-ak-cartp-step]');
      if (step) {
        var line = step.dataset.line;
        change(line, Math.max(0, qtyFor(line) + Number(step.dataset.akCartpStep)));
        return;
      }
      var remove = e.target.closest('[data-ak-cartp-remove]');
      if (remove) change(remove.dataset.line, 0);
    });

    root.addEventListener('change', function (e) {
      var input = e.target.closest('[data-ak-cartp-qty]');
      if (input) change(input.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
    });

    bind();
  }

  function boot() {
    document.querySelectorAll('[data-ak-cartp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
